import { Href } from "../../../../Constant";
import { SCROLLABLE_LIST } from "../../../../Data/UiKit/Lists";
import { H6, Image, LI, P } from "../../../../AbstractElements";

export const DynamicScrollableLists = () => {
  return (
    <>
      {SCROLLABLE_LIST.map(({ src, title, mail, days }, index) => (
        <LI tag="a" className="list-group-item-action list-hover-primary" href={Href} key={index}>
          <div className="list-wrapper gap-0">
            <Image className="list-img" src={src} alt="profile" />
            <div className="list-content">
              <H6>{title}</H6>
              <P>{mail}</P>
              <small className="text-muted">{days}</small>
            </div>
          </div>
        </LI>
      ))}
    </>
  );
};
